import styled, { css } from 'styled-components'
import { Row, Column } from '@sainsburys-tech/bolt'
import { ChevronIcon } from '@sainsburys-tech/bolt-icons'
import { remCalculator, colorSelector } from '../../../helpers/theming/utilities'
import { themeContract } from './M008.theme.contract'

const Chevron = styled(ChevronIcon)`
  ${(props) => css`
    min-width: 1em;
    stroke: ${colorSelector(
      props.textColor,
      props.theme.color.palette[themeContract[props.theme.channel].link.defaultColor],
      props.theme
    )};
  `}
`

const Wrapper = styled(Row)`
  background-color: ${(props) => props.theme.color.monochrome[themeContract[props.theme.channel].background.color]};
  margin-bottom: ${(props) => remCalculator(props.theme.size.spacing.lg)};
  height: 210px;
  display: flex;
  justify-content: center;

  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        justify-content: space-between;
      }
    `}
`

const ImageWrapper = styled(Column)`
  height: 100%;

  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].xs}) {
        display: none;
      }
    `}

  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        display: block;
      }
    `}

  img {
    height: 100%;
    max-width: 100%;
    object-fit: cover;
  }
`

const ListContainer = styled(Column)`
  display: flex;
  flex: inherit;
  min-width: 100%;

  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        flex: 1;
        align-items: center;
        min-width: auto;
        margin-right: 15px;
      }
    `}
`

const LinksContainer = styled(Row)`
  align-self: flex-start;
  padding: ${(props) => remCalculator(props.theme.size.spacing.lg)} 0;

  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        align-self: auto;
      }
    `}
`

const Link = styled.a`
  color: ${(props) =>
    colorSelector(
      props.textColor,
      props.theme.color.palette[themeContract[props.theme.channel].link.defaultColor],
      props.theme
    )};
  margin-bottom: 11px;
  text-decoration: none;
  display: flex;
  justify-content: space-between;

  &:last-child {
    margin-left: auto;
    margin-bottom: 0;
  }
`

export { Chevron, Wrapper, ImageWrapper, ListContainer, LinksContainer, Link }
